(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function el() { return document.querySelector('[data-pg-quote-page]'); }

  function money(cents) {
    var digits = cents % 100 === 0 ? 0 : 2;
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  }

  function cartApi(path, body) {
    if (window.pgQuote) return window.pgQuote.api(path, body);
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(root + path, opts).then(function (r) { return r.json(); });
  }

  function syncHeader() {
    if (window.pgQuote) window.pgQuote.refresh();
  }

  function change(key, qty) {
    var page = el();
    if (page) page.classList.add('is-busy');
    return cartApi('cart/change.js', { id: key, quantity: qty })
      .then(function (c) { render(c); syncHeader(); })
      .catch(function () { load(); })
      .then(function () { if (page) page.classList.remove('is-busy'); });
  }

  function row(item) {
    var r = document.createElement('div');
    r.className = 'qrow';
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
    r.innerHTML =
      '<a class="qthumb" href="' + item.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="qph"></span>') + '</a>' +
      '<div class="qmeta"><a class="qtitle" href="' + item.url + '"></a><p class="qsub"></p>' +
        '<div class="qqty">' +
          '<button type="button" data-step="-1" aria-label="Decrease quantity">&minus;</button>' +
          '<input type="number" min="0" max="99" inputmode="numeric" aria-label="Quantity">' +
          '<button type="button" data-step="1" aria-label="Increase quantity">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="qprice"></div>' +
      '<button type="button" class="qdel">Remove</button>';

    r.querySelector('.qtitle').textContent = item.product_title.replace('SAMPLE: ', '');
    var sub = r.querySelector('.qsub');
    if (item.product_type) sub.textContent = item.product_type + (item.sku ? '  ·  ' + item.sku : ''); else sub.remove();

    var price = r.querySelector('.qprice');
    price.textContent = money(item.final_line_price);
    if (item.quantity > 1) {
      var each = document.createElement('small');
      each.textContent = money(item.final_price) + ' each';
      price.appendChild(each);
    }

    var input = r.querySelector('input');
    input.value = item.quantity;
    input.addEventListener('change', function () {
      var q = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
      change(item.key, q);
    });
    r.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        change(item.key, Math.max(0, item.quantity + Number(b.getAttribute('data-step'))));
      });
    });
    r.querySelector('.qdel').addEventListener('click', function () { change(item.key, 0); });
    return r;
  }

  function render(cart) {
    var page = el();
    if (!page) return;
    var empty = page.querySelector('[data-empty]');
    var live = page.querySelector('[data-live]');
    var rows = page.querySelector('[data-rows]');
    var count = page.querySelector('[data-count]');
    var total = page.querySelector('[data-total]');
    var save = page.querySelector('[data-save]');
    var payload = page.querySelector('[data-payload]');

    if (count) count.textContent = cart.item_count;

    if (!cart.item_count) {
      if (empty) empty.hidden = false;
      if (live) live.hidden = true;
      if (payload) payload.value = '';
      return;
    }
    if (empty) empty.hidden = true;
    if (live) live.hidden = false;

    rows.innerHTML = '';
    var lines = [];
    cart.items.forEach(function (item, ix) {
      rows.appendChild(row(item));
      lines.push((ix + 1) + '. ' + item.product_title + '  x' + item.quantity + '  ' + money(item.final_line_price) + '  ' + location.origin + item.url);
    });

    if (total) total.textContent = money(cart.total_price);
    if (save) {
      var map = {};
      var src = page.querySelector('[data-compare]');
      try { map = JSON.parse(src ? src.textContent : '{}'); } catch (e) {}
      var diff = cart.items.reduce(function (sum, i) {
        var list = map[i.variant_id] || i.original_price;
        return sum + Math.max(0, (list - i.final_price) * i.quantity);
      }, 0);
      save.hidden = diff <= 0;
      save.textContent = diff > 0 ? 'You save ' + money(diff) + ' off list price' : '';
    }
    if (payload) {
      payload.value = lines.join('\n') + '\n\nEquipment subtotal: ' + money(cart.total_price) + '\nExcludes freight, surfacing and installation.';
    }
  }

  function load() {
    return cartApi('cart.js').then(render).catch(function () {});
  }

  function init() {
    var page = el();
    if (!page || page.dataset.bound === '1') return;
    page.dataset.bound = '1';

    var clear = page.querySelector('[data-clear-quote]');
    if (clear) {
      clear.addEventListener('click', function () {
        cartApi('cart/clear.js', {}).then(function (c) { render(c); syncHeader(); });
      });
    }

    document.addEventListener('pg:cart', function (e) { render(e.detail); });
    load();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
